import { calcTotalEnergy, calcTotalSave, getRecommand } from '@/constants/cost-saving';
import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from 'elem/compCommon/EFPicture';
import { cloneDeep } from 'lodash';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import BestSelling from './BestSelling';
import css from './index.module.scss';
import 'swiper/scss';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';

export default function G({ callBuy, updateSolar }: any) {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('costsaving-new');
    const { locale } = useRouter();
    const [gap, setGap] = useState(24);
    const [flag, setFlag] = useState(false);
    const [flag2, setFlag2] = useState(false);
    const [flag3, setFlag3] = useState(false);

    const SolarPanels = [
        {
            img: '',
            quantity: 1,
            isActive: true,
            energy: 400,
            id: '400w_rigid',
            title: '400w RIGID',
            cartTitle: '400w RIGID',
            productId: (() => {
                const localMap: any = {
                    us: '6841245925449',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40250363478089',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: true,
            energy: 800,
            id: '2*400w_rigid',
            title: '2 x 400W Rigid',
            cartTitle: '2 x 400W Rigid',
            productId: (() => {
                const localMap: any = {
                    us: '6841245925449',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40250363478089',
                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: true,
            energy: 400,
            id: '400w',
            title: t('secG_card_400w'),
            cartTitle: t('secG_cart_400w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',

                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998021697609',

                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 220,
            id: '220w',
            title: t('secG_card_220w'),
            cartTitle: t('secG_cart_220w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',

                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41670394576969',

                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 160,
            id: '160w',
            title: t('secG_card_160w'),
            cartTitle: t('secG_cart_160w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '4605523198025',

                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40573832429641',

                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 125,
            id: '125w',
            title: '125W',
            cartTitle: '125W',
            productId: (() => {
                const localMap: any = {
                    us: '7354152681545',

                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41838060404809',

                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 110,
            id: '110w',
            title: t('secG_card_110w'),
            cartTitle: t('secG_cart_110w_name'),
            productId: (() => {
                const localMap: any = {
                    us: '4318647222345',

                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '39998109941833',

                };
                return localMap[locale] || localMap.us;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 500,
            id: '500w',
            title: t('secG_card_500w'),
            cartTitle: t('secG_cart_500w_name'),
            productId: (() => {
                const localMap: any = {
                    ca: '15030544531827',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '52317425009011',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },

        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 800,
            id: '2*400w',
            title: '2 x 400W',
            cartTitle: '2*400W Portable Solar Panel',
            productId: (() => {
                const localMap: any = {
                    us: '6618094960713',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553987612745',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 500,
            id: '4*125w',
            title: '500W Solar Kit',
            cartTitle: '500W Solar Kit',
            productId: (() => {
                const localMap: any = {
                    us: '7354152681545',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41838060404809',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 440,
            id: '2*220w',
            title: '2 x 220W',
            cartTitle: '2 x 220W Portable Solar Panel',
            productId: (() => {
                const localMap: any = {
                    us: '7003545108553',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54553987547209',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
        {
            img: '',
            quantity: 1,
            isActive: false,
            energy: 200,
            id: '2*100w_rigid',
            title: '2 x 100W Rigid',
            cartTitle: '2 x 100W Rigid',
            productId: (() => {
                const localMap: any = {
                    us: '6808946278473',
                };
                return localMap[locale] || localMap.ca;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40133459640393',
                };
                return localMap[locale] || localMap.ca;
            })(),
        },
    ];

    const [solarpanels, setSolarpanels] = useState(SolarPanels);




    let cards = [
        {
            tag: t('common_card_tag'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1769570902105/Frame%202094655035.png',
            title: ' 1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Batteries',
            power: '12kWh | 12kW | 120V & 240V',
            id: 'dpux',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-ultra-x?variant=54714781171785',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15391292588105',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54714781171785',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['12kWh–180kWh expandable capacity with up to 30 batteries', '12–36kW output with up to 3 inverters', 'Powers 5-ton central A/ C'],
            children: solarpanels.filter((item: any) => (['400w']).includes(item.id)),
        },
        {
            tag: t('common_card_tag'),
            img: 'https://websiteoss.ecoflow.com/upload/image/1769570902331/Frame%202094655034.png',
            title: 'EcoFlow DELTA Pro Ultra',
            power: '6kWh | 7200W | 120V/240V',
            id: 'dpu',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-ultra-includes-extra-battery?variant=41963472289865',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7383152951369',
                    ca: '8006700236954',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41963472289865',
                    ca: '44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['5.6-16.8kW dual solar input', '80% capacity after 3500+ cycles', '5 charging options'],
            children: solarpanels.filter((item: any) => (locale === 'us' ? ['2*400w_rigid', '400w'] : ['400w', '500w']).includes(item.id)),
        },
        {
            tag: t('common_card_tag'),
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875722852/sl_DP3.png',
            title: 'EcoFlow DELTA Pro 3',
            power: '4-48kWh | 4000W｜120V/240V',
            id: 'deltapro3',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-3-portable-power-station?variant=41385721004105',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7185477075017',
                    ca: '8231332380826',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41385721004105',
                    ca: '44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['2600W Dual Solar Input', 'LFP battery, 4000 cycles to 80%, with an 11-year+ life span', 'Charging from 0-80% in 50 min'],
            children: solarpanels.filter((item: any) => (locale === 'us' ? ['400w', '220w', '125w'] : ['400w', '220w', '500w']).includes(item.id)),
        },
        {
            tag: t('common_card_tag'),
            img: '',
            title: 'DELTA 3 Ultra Plus',
            power: '3072Wh Capacity | 3600W Output | Smart Output Priority ',
            id: 'delta3ultraplus',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705008713',
                    ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62106740556147',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386143096905',
                    ca: '15164531016051',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54718705008713',
                    ca: '62106740556147',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                'Run your energy-hungry appliances with industry-leading output',
                'Extend runtime for your high-priority items using the smart output priority feature. ',
                'Supports 6 fast-charging methods.',
            ],
            children: solarpanels.filter((item: any) => ['400w', '2*400w', '4*125w'].includes(item.id)),
        },
        {
            img: ``,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: t('secG_card1_power'),
            title: t('secG_card1_title'),
            id: 'deltapro',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-pro-portable-power-station?variant=40516140138569',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station?variant=43725958873242',
                    za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station?variant=41601871610065',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6585086836809',
                    ca: '6944959824026',
                    za: '7027758137553',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40516140138569',
                    ca: '43725958873242',
                    za: '41601871610065',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secG_card1_desc1'), t('secG_card1_desc2'), t('secG_card1_desc3')],
            children: solarpanels.filter((item: any) => {
                const keys: {
                    [key: string]: any;
                } = {
                    za: ['400w', '220w', '160w'],
                    ca: ['400w', '220w', '500w'],
                    us: ['400w', '220w'],
                };
                return (keys?.[locale] || ['400w', '220w']).includes(item.id);
            }),
        },
        {
            tag: t('common_card_tag'),
            img: '',
            title: 'DELTA 3 Max Plus',
            power: '2048Wh Capacity | 2400W Output | 10ms UPS',
            id: 'delta3maxplus',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
                    ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661618035',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386147061833',
                    ca: '15164532654451',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54718699962441',
                    ca: '62106661618035',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                'The most lightweight 2kWh portable power station.* Cover your home essentials and outdoor adventures with quiet and reliable power.',
            ],
            children: solarpanels.filter((item: any) => ['400w', '4*125w'].includes(item.id)),
        },
        {
            img: ``,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: t('secG_card2_power'),
            title: t('secG_card2_title'),
            id: 'delta2max',
            bestSelling: true,
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station?variant=40538145095753',
                    ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=43592212775066',
                    za: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station?variant=41935518335185',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6905537888329',
                    ca: '7825964400794',
                    za: '7352407982289',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40538145095753',
                    ca: '43592212775066',
                    za: '41935518335185',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secG_card2_desc1'), t('secG_card2_desc2'), t('secG_card2_desc3')],
            children: solarpanels.filter((item: any) =>
                (locale === 'za' ? ['400w', '220w', '160w', '120w'] : ['400w', '220w', '160w', '110w']).includes(item.id),
            ),
        },
        {
            img: ``,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: '1024Wh |1800W',
            title: 'DELTA 3 Classic',
            id: 'delta3classic',
            bestSelling: true,
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54691871227977',
                    ca: 'https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639584627',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386067730505',
                    ca: '15164532916595',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54691871227977',
                    ca: '62060639584627',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['Ultra-versatile 4 charging options and a 45-minute fast-charge.'],
            children: solarpanels.filter((item: any) => ['220w', '2*100w_rigid'].includes(item.id)),
        },
        // ...cards,

        {
            img: ``,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: '3072Wh Capacity | 3600W Output | 4 Charging Options',
            title: 'DELTA 3 Ultra',
            id: 'delta3ultra',
            bestSelling: true,
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692148871241',
                    ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62060629590387',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386143096905',
                    ca: '15164531016051',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54692148871241',
                    ca: '62060629590387',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                'Sufficient power for daily use and essential backups.',
                '4 charging options including AC, solar, alternator, and generator charging.',
            ],
            children: solarpanels.filter((item: any) => ['400w', '4*125w', '2*220w'].includes(item.id)),
        },
        {
            img: ``,
            tag: locale === 'ca' ? '' : t('common_card_tag'),
            power: '2048Wh Capacity | 2400W Output | 10ms UPS',
            title: 'DELTA 3 Max',
            id: 'delta3max',
            bestSelling: true,
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873',
                    ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62060638372211',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '15386147061833',
                    ca: '15164532654451',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54692162764873',
                    ca: '62060638372211',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                'The most lightweight 2kWh portable power station.* Cover your home essentials and outdoor adventures with quiet and reliable power.',
                'Lightweight for on-the-go adventures, charged with solar energy in approx. 11.6 hours with 220W solar panel.',
                'Compared with EcoFlow DELTA 2 Max.',
            ],
            children: solarpanels.filter((item: any) => ['2*220w', '400w', '4*125w'].includes(item.id)),
        },
    ];




    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            const targetChild = card?.children?.find((child: any) => child?.isActive);
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('secC_title'),
                product_name: card?.title,
                price: card?.discountPrice + (targetChild ? targetChild?.discountPrice * targetChild?.quantity : 0),
                tag: card?.tag || 'none',
                quantity: card?.quantity || 1,
                button_name: t('common_card_buy'),
            });

            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {

            const target = card?.children?.find((item: any) => item.isActive);
            const addCarts: any = [
                {
                    discountPrice: card?.discountPrice,
                    originalPrice: card?.originalPrice,
                    inventory: card?.inventory,
                    productId: card?.productId,
                    variantId: card?.variantId,
                    img: card?.img,
                    title: card?.title,
                },
            ];
            if (target?.quantity) {
                addCarts.push({
                    discountPrice: target?.discountPrice,
                    originalPrice: target?.originalPrice,
                    inventory: target?.inventory,
                    productId: target?.productId,
                    variantId: target?.variantId,
                    img: target?.img,
                    title: target?.cartTitle,
                    quantity: target?.quantity,
                    parentVariantId: target?.parentVariantId,
                });
            }
            callBuy(addCarts);
        }
    };

    const handleClick = (card: any, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        const activeIdx = tempChildren.findIndex((item: any) => item.isActive);
        tempChildren[activeIdx].isActive = false;
        tempChildren[m].isActive = true;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCount = (data: any, num: number, k: number, m: number) => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const tempChildren = JSON.parse(JSON.stringify(tempArr[k].children));
        tempChildren[m].quantity = num;
        setSolarStatu(tempArr[k], tempChildren[m]);
        handleCalclate(tempArr[k], tempChildren[m]);
        const newArr = JSON.parse(JSON.stringify([...tempArr?.slice(0, k), { ...tempArr[k], children: [...tempChildren] }, ...tempArr?.slice(k + 1)]));
        setCardLists(newArr);
    };

    const handleCalclate = (card: any, list: any) => {
        card.energy = calcTotalEnergy(list?.energy, list?.quantity);
        card.saveMoney = calcTotalSave(list?.energy, list?.quantity, locale);
    };

    const setSolarStatu = (item: any, child?: any) => {
        if (!child && item?.children && item?.children.length) {
            child = JSON.parse(JSON.stringify(item?.children?.find((list: any) => list?.isActive)));
        }
        // 推荐状态：0 数量0-置灰 1：推荐 2:不推荐
        item.statu = child?.quantity === 0 ? 0 : child?.recommand?.includes(child?.quantity) ? 1 : 2;
    };

    const AddSubtractor = ({ data, callback, k, m }: any) => {
        const NUM_MIN = 0;
        const NUM_MAX = data?.inventory ?? 1000;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 1);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1, k, m);
        };

        const addNumber = () => {
            if (number >= NUM_MAX) return false;
            setNumber(number + 1);
            callback(data, number + 1, k, m);
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX || !Boolean(Number(v))) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v), k, m);
        };

        return (
            <div className="addSubtractor">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        {/* <g opacity="0.4"> */}
                        <path d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7.75781 11.2002C7.3436 11.2002 7.00781 11.536 7.00781 11.9502C7.00805 12.3642 7.34375 12.6992 7.75781 12.6992H16.2422C16.6563 12.6992 16.9919 12.3642 16.9922 11.9502C16.9922 11.536 16.6564 11.2002 16.2422 11.2002H7.75781Z" fill="#18191B" />
                        {/* </g> */}
                    </svg>
                </div>
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="black" />
                        <path d="M12.0117 6.85938C12.4257 6.85963 12.7607 7.19532 12.7607 7.60938V11.2012H16.3408C16.7547 11.2014 17.0897 11.5372 17.0898 11.9512C17.0898 12.3652 16.7548 12.7009 16.3408 12.7012H12.7607V16.2939C12.7605 16.7078 12.4256 17.0427 12.0117 17.043C11.5976 17.043 11.2619 16.708 11.2617 16.2939V12.7012H7.65625C7.24204 12.7012 6.90625 12.3654 6.90625 11.9512C6.9064 11.5371 7.24213 11.2012 7.65625 11.2012H11.2617V7.60938C11.2617 7.19516 11.5975 6.85938 12.0117 6.85938Z" fill="white" />
                    </svg>
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    const getAsynItem = async (item: any) => {
        const { productId, variantId, link_more } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);

                if (res?.code === '0') {
                    item.discountPrice = res?.data?.price;
                    item.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                    item.inventory = res?.data?.inventoryQuantity ?? undefined;
                    item.skuTitle = res?.data?.skuTitle ?? undefined;
                    // item.inventory = 1;
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    if (link_more) {
                        handleCalclate(item, item.children[0]);
                    }
                    if (!item?.img && res?.data?.variantImg) {
                        item.img = res?.data?.variantImg;
                    }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        if (flag) {
            const tempSolarPanelsArr = JSON.parse(JSON.stringify(SolarPanels));
            const solarPromises = tempSolarPanelsArr?.map((item: any) => getAsynItem(item));
            Promise.all(solarPromises)
                .then(() => {
                    setSolarpanels(tempSolarPanelsArr?.filter((list: any) => list?.inventory !== undefined));
                    setFlag2(true);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [flag]);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardLists));
        const promises = tempArr?.map((item: any) => getAsynItem(item));
        Promise.all(promises)
            .then(() => {
                setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
                setFlag(true);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    useEffect(() => {
        if (flag && flag2) {
            const tempArr = JSON.parse(JSON.stringify(cardLists));

            tempArr?.map((item: any) => {
                // item.children = JSON.parse(
                //     JSON.stringify(item?.id === 'deltapro3' ? solarpanels.slice(0, 2) : item?.id === 'deltapro' ? solarpanels.slice(0, 3) : solarpanels),
                // );

                item.children = cloneDeep(
                    item.children.map((child: any) => {
                        return solarpanels.find((item: any) => item.id === child.id);
                    }),
                ).filter((item: any) => !!item);
                item.children.forEach((item: any) => (item.isActive = false));
                if (item.children[0]) {
                    item.children[0].isActive = true;
                }

                if (['us', 'ca'].includes(locale)) {
                    if (['d3p', 'delta2max', 'delta2'].includes(item.id)) {
                        const _item = item.children.find((item: any) => item.id === '220w');
                        if (_item) {
                            _item.bestSelling = true;
                        }
                    }
                }

                item?.children?.map((child: any) => {
                    child.cartTitle = `${child?.cartTitle} (${item?.title})`;
                    child.parentVariantId = item?.variantId;
                    child.recommand = getRecommand(item?.id, String(child?.id));
                    if (child?.inventory < 0) {
                        child.quantity = 0;
                    } else if (child?.recommand?.length > 0 && child?.inventory < child?.recommand[0]) {
                        child.quantity = child?.inventory;
                    } else {
                        child.quantity = child?.recommand?.length > 0 ? child?.recommand[0] : 0;
                    }
                });
                setSolarStatu(item, item?.children[0]);
                handleCalclate(item, item?.children[0]);
            });
            setCardLists(tempArr);
            setFlag3(true);
        }
    }, [solarpanels, flag, flag2]);

    useEffect(() => {
        const flag = solarpanels?.find((sp: any) => sp?.variantId === updateSolar?.variantId);
        if (updateSolar && flag) {
            const tempSolarArr = JSON.parse(JSON.stringify(solarpanels));
            const tempArr = JSON.parse(JSON.stringify(cardLists));
            const cardTargetIdx = tempArr?.findIndex((item: any) => item?.variantId === updateSolar?.parentVariantId);
            if (cardTargetIdx !== -1) {
                const solarTargetIdx = tempArr[cardTargetIdx]?.children.findIndex((item: any) => item?.variantId === updateSolar?.variantId);
                if (solarTargetIdx !== -1) {
                    tempArr[cardTargetIdx]['children'][solarTargetIdx]['quantity'] = updateSolar?.quantity;
                    setSolarStatu(tempArr[cardTargetIdx]);
                    handleCalclate(tempArr[cardTargetIdx], tempArr[cardTargetIdx]['children'][solarTargetIdx]);
                    setCardLists(tempArr);
                }
            }
        }
    }, [updateSolar]);
    useCardsShowHook('.cost-saving-G .swiper-box .swiper-item', '.cost-saving-G');
    return (
        <div id="cost-saving-G" className={`cost-saving-G  ${css['cost-saving-G']} GtmModuleData-section`} data-section-id={'cost-saving-G'} data-section-title={'cost-saving-G'}>
            <Swiper
                className="cards swiper-box"
                modules={[Navigation, Scrollbar]}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation={{
                    nextEl: '.eco-swiper-button-next',
                    prevEl: '.eco-swiper-button-prev',
                }}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cardLists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        {card?.tag && <span className="card-tag">{card?.tag}</span>}
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.title} />
                        </div>
                        <p className="card-power">{card?.power}</p>
                        <p className="card-title">{card?.title}</p>
                        <ul className="card-descs">
                            {card?.descArr?.map((desc: any, m: number) => (
                                <li className="card-desc li" key={`${k}_${m}`}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        {/* <p className="card-line"></p> */}
                        <div className={`calc-info`}>
                            <p className={`card-calc`}>{t('common_card_calculator')}</p>
                            <p className={`card-calc-res ${card?.statu === 0 ? 'gray' : card?.statu === 1 ? 'recommand' : 'not-recommand'}`}>
                                {card?.statu === 0
                                    ? t('common_card_0')
                                    : card?.statu === 1
                                        ? t.rich('common_card_calculator_res', {
                                            power: card?.energy,
                                            money: card?.saveMoney,
                                            h: (text: string) => (
                                                <span className="h">
                                                    {t('common_card_unit')}
                                                    {text}
                                                </span>
                                            ),
                                        })
                                        : t('common_card_no_recommand')}
                            </p>
                        </div>
                        <div className="card-output">
                            <p className="output-text">{t('secG_card_output')}</p>
                            <ul className="output-lists">
                                {card?.children?.map((list: any, m: number) => (
                                    <li className={`output-list ${list?.isActive ? 'active' : ''}`} key={`${k}_${m}`} onClick={() => handleClick(card, k, m)}>
                                        {list?.title}

                                        {list?.bestSelling && <BestSelling className="best-selling" />}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="card-quantity card-output">
                            {/* <p className="output-text">{t('secG_card_quantity')}</p> */}
                            <ul className="quantity-lists">
                                {card?.children?.map((list: any, m: number) => (
                                    <li className={`quantity-list ${list?.isActive ? 'show' : 'hide'}`} key={`${k}_${m}`}>
                                        <AddSubtractor data={list} callback={handleCount} k={k} m={m} />
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="card-btns">
                            {card?.link_buy && (
                                <>
                                    {Number(card?.inventory) <= 0 ? (
                                        <button disabled className={`btn-buy card-btn disable`}>
                                            {t('common_card_out')}
                                        </button>
                                    ) : (
                                        <p className={`btn-buy card-btn`} onClick={() => {
                                            gtm.push({
                                                __btn_id1: `item-${k + 1} .btn-buy .card-btn`,
                                                __btn_id2: t('common_card_buy'),
                                                __btn_type: 'text',
                                            })
                                            flag && flag2 && flag3 && handleBuy(card)
                                        }}>
                                            {t('common_card_buy')}
                                        </p>
                                    )}
                                </>
                            )}
                            {card?.link_more && (
                                <Link
                                    className="btn-more card-btn"
                                    href={`${card?.link_more}${String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                        }utm_source=scenario+page&utm_medium=Pillar`}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: card?.title,
                                        position: 'Cost Saving Page',
                                        __btn_id1: `item-${k + 1} .btn-more .card-btn`,
                                        __btn_id2: `${card?.link_more}${String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                            }utm_source=scenario+page&utm_medium=Pillar`,
                                        __btn_type: 'href',
                                    }}
                                >
                                    {t('common_card_more')}
                                </Link>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
                <div className={`eco-swiper-control eco-swiper-control-black`}>
                    <div className="eco-swiper-navigation">
                        <div className="eco-swiper-button-prev">
                            <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                        </div>
                        <div className="eco-swiper-button-next">
                            <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                        </div>
                    </div>
                </div>
            </Swiper>
        </div>
    );
}
